import { SVGProps } from "react"
const MapListIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="4" y="4" width="7" height="7" rx="2.5" fill="black" />
    <rect x="4" y="4" width="7" height="7" rx="2.5" fill="black" fill-opacity="0.2" />
    <rect x="4" y="4" width="7" height="7" rx="2.5" fill="black" fill-opacity="0.2" />
    <rect x="4" y="4" width="7" height="7" rx="2.5" fill="black" fill-opacity="0.2" />
    <rect x="4" y="4" width="7" height="7" rx="2.5" stroke="white" stroke-width="0.32" />
    <rect x="4" y="14" width="7" height="7" rx="2.5" fill="black" />
    <rect x="4" y="14" width="7" height="7" rx="2.5" fill="black" fill-opacity="0.2" />
    <rect x="4" y="14" width="7" height="7" rx="2.5" fill="black" fill-opacity="0.2" />
    <rect x="4" y="14" width="7" height="7" rx="2.5" fill="black" fill-opacity="0.2" />
    <rect x="4" y="14" width="7" height="7" rx="2.5" stroke="white" stroke-width="0.32" />
    <rect x="14" y="4" width="7" height="7" rx="2.5" fill="black" />
    <rect x="14" y="4" width="7" height="7" rx="2.5" fill="black" fill-opacity="0.2" />
    <rect x="14" y="4" width="7" height="7" rx="2.5" fill="black" fill-opacity="0.2" />
    <rect x="14" y="4" width="7" height="7" rx="2.5" fill="black" fill-opacity="0.2" />
    <rect x="14" y="4" width="7" height="7" rx="2.5" stroke="white" stroke-width="0.32" />
    <rect x="14" y="14" width="7" height="7" rx="2.5" fill="black" />
    <rect x="14" y="14" width="7" height="7" rx="2.5" fill="black" fill-opacity="0.2" />
    <rect x="14" y="14" width="7" height="7" rx="2.5" fill="black" fill-opacity="0.2" />
    <rect x="14" y="14" width="7" height="7" rx="2.5" fill="black" fill-opacity="0.2" />
    <rect x="14" y="14" width="7" height="7" rx="2.5" stroke="white" stroke-width="0.32" />
  </svg>
)
export default MapListIcon
